module.exports = __webpack_public_path__ + "img/photos-12.cb31f7fc.png";